var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7488 3.75002C17.3981 3.74064 11.5425 7.17752 8.45437 12.7275C5.36625 18.2775 5.53313 25.0669 8.88938 30.4575L5.625 39.375L14.5406 36.1106C20.8481 40.02 28.9369 39.525 34.7194 34.8731C40.5019 30.2213 42.72 22.4269 40.2525 15.4275C37.7869 8.42627 31.17 3.74627 23.7488 3.75002Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.18 15C29.9888 15 31.875 17.6194 31.875 20.0587C31.875 25.0088 24.0487 29.0625 23.9062 29.0625C23.7638 29.0625 15.9375 25.0088 15.9375 20.0587C15.9375 17.6194 17.8237 15 20.6325 15C22.2394 15 23.295 15.795 23.9062 16.5038C24.5156 15.795 25.5713 15 27.18 15Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationMessages);
export default __webpack_public_path__ + "static/media/navigation-messages.cfcf2743.svg";
export { ForwardRef as ReactComponent };